/**
 * Contact Model
 * 문의 도메인 모델
 */

import { ServiceType } from './AdminUser';

export type ContactStatus = 'pending' | 'in_progress' | 'completed' | 'rejected';

export interface Contact {
  id: string;
  name: string;
  email: string;
  phone?: string;
  service_type: ServiceType;
  message: string;
  status: ContactStatus;
  assigned_to?: string;
  assigned_to_name?: string;
  response?: string;
  responded_at?: string;
  created_at: string;
  updated_at: string;
}

export interface ContactAssignRequest {
  contact_id: string;
  admin_id: string;
}

export interface ContactResponseRequest {
  contact_id: string;
  response: string;
}

export interface ContactRejectRequest {
  contact_id: string;
  rejection_reason: string;
}

export interface ContactStatusUpdateRequest {
  contact_id: string;
  status: ContactStatus;
}

// Helper functions
export const getContactStatusText = (status: ContactStatus): string => {
  const statusTexts: Record<ContactStatus, string> = {
    pending: '대기 중',
    in_progress: '처리 중',
    completed: '완료',
    rejected: '거부',
  };
  return statusTexts[status];
};

export const getContactStatusColor = (status: ContactStatus): string => {
  const statusColors: Record<ContactStatus, string> = {
    pending: 'yellow',
    in_progress: 'blue',
    completed: 'green',
    rejected: 'red',
  };
  return statusColors[status];
};

export const canRespond = (contact: Contact): boolean => {
  return contact.status === 'pending' || contact.status === 'in_progress';
};

export const isAssigned = (contact: Contact): boolean => {
  return !!contact.assigned_to;
};

export const isContactPending = (contact: Contact): boolean => {
  return contact.status === 'pending';
};

export const isContactInProgress = (contact: Contact): boolean => {
  return contact.status === 'in_progress';
};

export const isContactCompleted = (contact: Contact): boolean => {
  return contact.status === 'completed';
};

// Aliases for backward compatibility
export const isPending = isContactPending;
export const isInProgress = isContactInProgress;
export const isCompleted = isContactCompleted;
